export enum CATEGORIES {
    TOTAL = 'TOTAL',
    PRODUCTION = 'PRODUCTION',
    CONSOMMATION = 'CONSOMMATION',
    STOCKAGE = 'STOCKAGE'
}

export enum CATEGORY_LABELS_ {
    TOTAL = 'Total',
    PRODUCTION = 'Projets de production',
    CONSOMMATION = 'Projets de consommation',
    STOCKAGE = 'Projets de stockage',
  }
  export enum CATEGORY_LABELS {
    TOTAL = 'Total',
    PRODUCTION = 'Production',
    CONSOMMATION = 'Consommation',
    STOCKAGE = 'Stockage',
  }
  export enum CATEGORY_COLORS {
    Rose = 'Production',
    Bleu = 'Consommation',
    Jaune = 'Stockage',
  }
  export enum COLOR_CATEGORIES {
    PRODUCTION = 'Rose',
    CONSOMMATION = 'Bleu',
    STOCKAGE = 'Jaune',
  }
  export enum ITEMS_COLOR {
    Rose = '#A364D0',
    Bleu = '#08AFE3',
    Jaune = '#FF9861',
  }

  export enum FRANCE_REGIONS {
    auvergne_rhone_alpes = 'Auvergne-Rhône-Alpes',
    bourgogne_franche_comte = 'Bourgogne-Franche-Comté',
    bretagne = 'Bretagne',
    centre_val_de_loire = 'Centre-Val de Loire',
    grand_est = 'Grand Est',
    hauts_de_france = 'Hauts-de-France',
    ile_de_france = 'Île-de-France',
    normandie = 'Normandie',
    nouvelle_aquitaine = 'Nouvelle-Aquitaine',
    occitanie = 'Occitanie',
    pays_de_la_loire = 'Pays de la Loire',
    provence_alpes_cote_d_azur = 'Provence-Alpes-Côte d\'Azur',
  }
  export const OPACITY_VALUE = 0.2;
  export const OPACITY_LEFT = 0.5;